/**
 * ビルドしたバンドル自身のバージョン（scripts/deploy.sh が public/version.json と同じ値を
 * REACT_APP_BUILD_VERSION として焼き込む。2026-10-22）。
 * 更新通知（UpdateNotifier・PWA の MobilePage）はこれとサーバの version.json を比べる。
 * 開発サーバや焼き込み無しのビルドでは null（従来どおり「最初に取れた version.json」を基準にする）。
 */
export const BUILD_VERSION: string | null = process.env.REACT_APP_BUILD_VERSION || null;
